//React
import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useTranslation, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//CSS, STYLES & MEDIA ASSETS
import "./Step1.scss";
//import logo from "../../utils/logo_MPDS.svg";
import logo from "../../utils/logo_MPDS_ecossistema.svg";
import "../../App.scss";

//ACTIONS
import { saveFreeTrial } from '../../store/actions/freetrial/freeTrialAction'

//FUNCTIONS
import { isDefined } from '../../utils/utils';

//OUTSIDE COMPONENTS
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'
//import Link from '@material-ui/core/Link';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '../../components/form/inputAuth'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import Confirmation from './Confirmation';

const languages = [
  {
    value: 'pt-PT',
    label: 'Português',

  },
  {
    value: 'en-US',
    label: 'English',
  }
];

function Page() {
  const { i18n } = useTranslation();

  const changeLanguage = (event, lng) => {
    i18n.changeLanguage(event, lng);
  };

  let languageStorage = localStorage.getItem('i18nextLng')
  if (languageStorage != null && languageStorage !== "") {
    if (languageStorage !== "pt-PT" && languageStorage !== "en-US") {
      if (languageStorage.length > 2) {
        let abrvLang = languageStorage.substr(0, 2).toLowerCase();
        if (abrvLang === "en") {
          languageStorage = 'en-US'
        } else {
          languageStorage = 'pt-PT'
        }
      } else {
        languageStorage = 'pt-PT'
      }
    }
  } else {
    languageStorage = 'pt-PT'
  }

  const [values, setValues] = React.useState({
    language: languageStorage
  });

  const handleChange = name => event => {
    setValues({ ...values, [name]: event.target.value });
    /** Change to the clicked language */
    changeLanguage(event.target.value)
  };

  return (
    <div className="text-center pb-5-freetrial mt-idioma">

      <TextField
        id="standard-select-currency"
        select
        inputProps={{ className: "pl-3" }}
        value={values.language}
        onChange={handleChange('language')}
        margin="normal"
      >

        {languages.map(option => (
          <MenuItem key={option.value} value={option.value} dense={true}>
            {option.label}
          </MenuItem>
        ))}


      </TextField>

    </div>
  );
}

class Step1FreeTrial extends Component {
  constructor(props) {
    super(props)
    this.state = { 
        name:  "",
        contacto: "",
        email: "",
        speciality: "",
        organizacao: "",
        terms: false,
        rgpd: false,
        showErrorMessage: false, 
        errorMessageSnack: "",
        showedError: false,
        redirect: false,
        showForm: true,
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCloseSnackBar = this.handleCloseSnackBar.bind(this);
    document.getElementById('root').style.background = "#f4fafb"

  }

  componentDidUpdate() {
    if (isDefined(this.props.freeTrial.errorCreateUser) && !this.state.showErrorMessage && !this.state.showedError) {
      this.setState({ showErrorMessage: true, errorMessageSnack: this.props.freeTrial.errorCreateUser, showedError: true })
      this.props.freeTrial.errorCreateUser = null
    }
    else if(this.props.freeTrial.successCreateUser == true)
    {
      
      this.setState({ redirect: true, showErrorMessage: false, errorMessageSnack: "", showedError: false, showForm: false });
      this.props.freeTrial.successCreateUser = null;
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({showedError: false})
    this.props.saveFreeTrial(this.state.name, this.state.email, this.state.contacto, this.state.speciality, this.state.organizacao);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleCloseSnackBar() {
    this.setState({
      showErrorMessage: false,
      errorMessageSnack: ""
    })
  }

  render(){
    const { t } = this.props;
    const { handleSubmit } = this.props;
    let form;
    const { redirect } = this.state;

    form = <form className="form-register" onSubmit={this.handleSubmit}>
        <Field
          value={this.state.name}
          color="primary"
          component={Input}
          type="text"
          name="name"
          required={true}
          label={t('FreeTrial.Name')}
          classes="login-input-bbottom mt-4"
          classesLabel="login-input-label"
          onChange={this.handleInputChange}
          errorState={this.state.showError && (this.props.loginU.errorEmailMsg != null || this.props.loginU.errorMsg != null) ? true : false}
          errorMessage={(this.state.showError && this.props.loginU.errorEmailMsg != null) ? t(this.props.loginU.errorEmailMsg) : ""}
        />
        <Field
          value={this.state.email}
          color="primary"
          component={Input}
          type="email"
          name="email"
          required={true}
          label={t('FreeTrial.Email')}
          classes="login-input-bbottom mt-4"
          classesLabel="login-input-label"
          onChange={this.handleInputChange}
          errorState={this.state.showError && (this.props.loginU.errorEmailMsg != null || this.props.loginU.errorMsg != null) ? true : false}
          errorMessage={(this.state.showError && this.props.loginU.errorEmailMsg != null) ? t(this.props.loginU.errorEmailMsg) : ""}
        />

        <Field
          value={this.state.contacto}
          color="primary"
          component={Input}
          type="text"
          name="contacto"
          required={true}
          label={t('FreeTrial.Contact')}
          classes="login-input-bbottom mt-4"
          classesLabel="login-input-label"
          onChange={this.handleInputChange}
          errorState={this.state.showError && (this.props.loginU.errorEmailMsg != null || this.props.loginU.errorMsg != null) ? true : false}
          errorMessage={(this.state.showError && this.props.loginU.errorEmailMsg != null) ? t(this.props.loginU.errorEmailMsg) : ""}
        />

        <Field
          value={this.state.speciality}
          color="primary"
          component={Input}
          type="text"
          name="speciality"
          required={true}
          label={t('FreeTrial.Speciality')}
          classes="login-input-bbottom mt-4"
          classesLabel="login-input-label"
          onChange={this.handleInputChange}
          errorState={this.state.showError && (this.props.loginU.errorEmailMsg != null || this.props.loginU.errorMsg != null) ? true : false}
          errorMessage={(this.state.showError && this.props.loginU.errorEmailMsg != null) ? t(this.props.loginU.errorEmailMsg) : ""}
        />

        <Field
          value={this.state.speciality}
          color="primary"
          component={Input}
          type="text"
          name="organizacao"
          required={false}
          label={t('FreeTrial.Organization')}
          classes="login-input-bbottom mt-4"
          classesLabel="login-input-label"
          onChange={this.handleInputChange}
/*           errorState={this.state.showError && (this.props.loginU.errorEmailMsg != null || this.props.loginU.errorMsg != null) ? true : false}
          errorMessage={(this.state.showError && this.props.loginU.errorEmailMsg != null) ? t(this.props.loginU.errorEmailMsg) : ""} */
        />

        <Checkbox
          checked={this.state.terms}
          id="terms"
          name="terms"
          required={true}
          onChange={this.handleInputChange}
          value={this.state.terms}
          inputProps={{ 'aria-label': 'checkbox with default color' }}
          className="checkbox-terms-freetrial"
          color="default" />
          <label htmlFor="terms" className="label-checkbox-freetrial-2">{t('FreeTrial.Terms1')} <a href="https://mpds.f3m.pt/termos-de-uso/" target="_blank" className="link-terms-freetrial"> {t('FreeTrial.Terms2')} </a> {t('FreeTrial.Terms3')}</label>

        { /*<FormControlLabel
                      className="label-checkbox-freetrial"
                      control={
                        <Checkbox
                            checked={this.state.terms}
                            name="terms"
                            required={true}
                            onChange={this.handleInputChange}
                            value={this.state.terms}
                            inputProps={{ 'aria-label': 'checkbox with default color' }}
                            color="default" />
                      } 
                      label={(t('FreeTrial.Terms1') + t('FreeTrial.Terms2') + t('FreeTrial.Terms3'))}
                    />      */}
        <br/><br/>
        <FormControlLabel
              className="label-checkbox-freetrial"
              control={
                  <Checkbox
                      checked={this.state.rgpd}
                      name="rgpd"
                      required={true}
                      onChange={this.handleInputChange}
                      value={this.state.rgpd}
                      inputProps={{ 'aria-label': 'checkbox with default color' }}
                      color="default" />
              }
              label={t('FreeTrial.RGPD')}
          />      

        <Button className="button-login d-block mx-auto my-5" color="primary" variant="contained" type="submit"><span className="px-5">{t('Submit')}</span></Button>
                  
      </form>

    return (
      <>
      {this.state.showForm ? 
      <Container className="background login-illustration-step1">
          <Row className="row-form-freetrial">
            <Col xs sm md={12} lg={12}> 
              <Page />
              <Image src={logo} className="App-logo d-block mx-auto my-md-5 my-3 mb-logo-trial" fluid alt="logo" />
              <div className="div-title-freetrial">
                <Link to="/register-trial">
                  {/* <IconButton fontSize="large" className="mr-1 outline-none" color="primary" type="submit"> */}
                    <ArrowBackIcon className="seta-freetrial"/>
                  {/* </IconButton> */}
                </Link>
                {/* <Link to="/register-trial"><img src="..\images\MaterialIcon.svg" className="seta-freetrial"></img></Link> */}
                <label className="signup">{t('FreeTrial.Signup')}</label>
              </div>              
              <label className="label-completeform">{t('FreeTrial.CompleteForm')}</label>
              <div className="container container-step1">
                {form}
              </div> 
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
              <div className="foot-confirmation-freetrial">
                <img width="200px" src="..\images\f3mfeelit-fundobranco.png" className="img-foot-confirmation-freetrial" alt=""></img>
                <div class="div-sabermais-freetrial pt-3">
                  <label className="label-sabermais-link"><a href={t('urlMpDSSite')} target="_blank">{t('FreeTrial.ClickHere')}</a></label> <label className="label-sabermais">{t('FreeTrial.MoreInformation')}</label>
                </div>
              </div>
            </Col >
          </Row>

          <Snackbar open={this.state.showErrorMessage} autoHideDuration={5000} onClose={this.handleCloseSnackBar} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
              <MuiAlert elevation={6} variant="filled" onClose={this.handleCloseSnackBar} severity="error">
                {t(this.state.errorMessageSnack)}
              </MuiAlert>
          </Snackbar>

          {/* {redirect ? <Redirect push to="/register-trial/confirmation" /> : <></>} */}

        </Container>
          :
          <Confirmation></Confirmation>
      }
      </>
        
    )
  } 
}

Step1FreeTrial = reduxForm({ form: 'step1Form' })(Step1FreeTrial)
const mapStateToProps = (state, ownProps) => ({ freeTrial: state.freeTrial });
const mapDispatchToProps = dispatch => bindActionCreators({ saveFreeTrial }, dispatch)
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Step1FreeTrial))
